import React from 'react';
import Popup from "./Popup";
import Message from "./Message";
import Logo from "./Logo";
import { useThemeContext } from "../contexts/ThemeContext";


function MessagePopup({title, message, onClose}) {
    const { theme } = useThemeContext();
    return (
        <Popup withOverlay withClose onClose={onClose}>
            <div className="pl-3 pr-3">
                <div className="mt-3 text-center">
                    <Logo className="logo mb-3" src={theme?.logo}/>
                    <h1 className="mb-4">{title}</h1>
                </div>
                <Message showIcon className="mb-4" type="message-success" message={message}/>
                <div className="text-center">
                    <button className="btn btn-primary" onClick={onClose}>Dismiss</button>
                </div>
            </div>
        </Popup>
    );
}
export default MessagePopup;